
import { ref } from 'vue';

import IftaLabel from 'primevue/iftalabel';
import InputText from 'primevue/inputtext';
import Password from 'primevue/password';
import Button from 'primevue/button';
import Divider from 'primevue/divider';

import { useAuthStore } from '../stores/auth';
import { showVuePopup } from '../utils/showVuePopup';
import ForgotPassword from './ForgotPassword.vue';
import PopupMainNavbar from '../components/navbar/PopupMainNavbar.vue';
import PopupAffiliateNavbar from '../components/navbar/PopupAffiliateNavbar.vue';
import Register from './Register.vue';
import { useToast } from 'primevue/usetoast';
import { storeToRefs } from 'pinia';
import { external } from '../apis/external';

export default {
	name: 'Login',
	components: {
		IftaLabel,
		InputText,
		Password,
		Divider,
		Button,
		PopupMainNavbar,
		PopupSubNavbar: PopupAffiliateNavbar,
	},
	props: {
		close: Function,
	},
	setup(props) {
		const auth = useAuthStore();
		auth.hydrate();
		const { profile } = storeToRefs(auth);

		const toast = useToast();

		const form = ref({
			username: {
				value: '',
				errorMsg: '',
				invalid: false,
			},
			password: {
				value: '',
				errorMsg: '',
				invalid: false,
			},
			btn: {
				disabled: false,
				loading: false,
			},
		})

		const btnClickRegister = () => {
			showVuePopup(Register, {}, {});
		}

		const clickBtnForgotPassword = () => {
			showVuePopup(ForgotPassword, {}, {});
		};



		const handleSubmit = async () => {

			form.value.btn.loading = true;

			try {
				if (form.value.username.value === '') {
					form.value.username.errorMsg = '';
					form.value.username.invalid = true;
					form.value.btn.loading = false;
					return;
				}
				if (form.value.password.value === '') {
					form.value.password.errorMsg = '';
					form.value.password.invalid = true;
					form.value.btn.loading = false;
					return;
				}

				await auth.login({
					username: form.value.username.value,
					password: form.value.password.value,
				});

				toast.add({ severity: 'success', summary: 'สำเร็จ', detail: 'เข้าสู่ระบบสำเร็จ', life: 3000 });

				props.close?.();

				window.location.href = '/slot';
			} catch (error: any) {
				toast.add({
					severity: 'error',
					summary: 'เกิดข้อผิดพลาด',
					detail: error,
					life: 3000,
				});
			} finally {
				form.value.btn.loading = false;
			}
		};

		return {
			form,
			handleSubmit,
			clickBtnForgotPassword,
			btnClickRegister,
		};
	},
};
